import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { HttpService } from '../../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root',
})
export class ImportacaoFuncionariosService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  saveEmployeeImport(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/employee/batch', data, successHandle, errorHandle);
  }
  findEnterpriseRates(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doGet('/enterprise/rates/info', data, successHandle, errorHandle);
  }
  buscaSaldoGlobal(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doGet('/enterprise/balanceLimit', data, successHandle, errorHandle);

  }
  buscaTaxas(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/returnReusedInterestRates', data, successHandle, errorHandle);

  }
  taxasTermos(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/reuse/enterprise-product', data, successHandle, errorHandle);

  }
  validaSocio(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doGet('/enterprise/validaSocio', data, successHandle, errorHandle);

  }
  buscarSaldoRecebiveis(data: any, successHandle: Function, errorHandle: Function) {

    this.httpService.doGet('/enterprise/returnRetailReceivablesBalance', data, successHandle, errorHandle);

  }
  buscarTaxaAgiliza(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/taxaAntecipacao', data, successHandle, errorHandle);
  }
  buscaBandeiras(empresaCnpj: any, produtId: any, data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/bandeiras/' + empresaCnpj + '/' + produtId, data, successHandle, errorHandle);

  }
  ratesEmitFirstLabelCopy(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doGet('/enterprise/ratesEmitFirstLabelCopy', data, successHandle, errorHandle);
  }

}
